import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  SparePartCatalogItemWithPrice,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.sparePart}sparepart/withSellingPrice/fullTextSearch`;

export interface GetSparePartCatalogsBySupplierIdQueryArgs {
  supplierId: string;
  sellerId: string;
  query?: string;
}

export const getSparePartCatalogsBySupplierIdRequest = (
  payload: GetSparePartCatalogsBySupplierIdQueryArgs,
): ApiRequestDescriptor => ({
  url: buildUrl(ENDPOINT, {
    supplierId: payload.supplierId,
    sellerId: payload.sellerId,
    searchTerm: payload.query,
  }),
  config: { method: SUPPORTED_METHODS.GET },
});

export const getSparePartCatalogsBySupplierIdQuery = async (
  payload: GetSparePartCatalogsBySupplierIdQueryArgs,
): Promise<
  BackResponse<SparePartCatalogItemWithPrice[]> | BackResponseFailure
> => {
  try {
    return await executeQuery<BackResponse<SparePartCatalogItemWithPrice[]>>(
      getSparePartCatalogsBySupplierIdRequest(payload),
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};
